module.exports = __webpack_public_path__ + "img/icon-trash-disabled.b309fe6d.svg";